export const STREAMING_PLATFORMS = [
  { value: "spotify", label: "Spotify", icon: "fa-brands fa-spotify", color: "#1DB954" },
  { value: "apple_music", label: "Apple Music", icon: "fa-brands fa-apple", color: "#FA586A" },
  { value: "youtube", label: "YouTube", icon: "fa-brands fa-youtube", color: "#FF0000" },
  { value: "youtube_music", label: "YouTube Music", icon: "fa-brands fa-youtube", color: "#FF3D3D" },
  { value: "soundcloud", label: "SoundCloud", icon: "fa-brands fa-soundcloud", color: "#FF5500" },
  { value: "deezer", label: "Deezer", icon: "fa-solid fa-circle-play", color: "#A238FF" },
  { value: "tidal", label: "Tidal", icon: "fa-solid fa-water", color: "#00FFFF" },
  { value: "amazon_music", label: "Amazon Music", icon: "fa-brands fa-amazon", color: "#00A8E1" },
  { value: "bandcamp", label: "Bandcamp", icon: "fa-brands fa-bandcamp", color: "#1DA0C3" },
  { value: "custom", label: "Custom Link", icon: "fa-solid fa-link", color: "#94A3B8" },
];

export const SOCIAL_PLATFORMS = [
  { value: "instagram", label: "Instagram", icon: "fa-brands fa-instagram" },
  { value: "tiktok", label: "TikTok", icon: "fa-brands fa-tiktok" },
  { value: "x", label: "X (Twitter)", icon: "fa-brands fa-x-twitter" },
  { value: "facebook", label: "Facebook", icon: "fa-brands fa-facebook" },
  { value: "youtube", label: "YouTube", icon: "fa-brands fa-youtube" },
  { value: "threads", label: "Threads", icon: "fa-brands fa-threads" },
];

export function platformMeta(value) {
  return STREAMING_PLATFORMS.find((p) => p.value === value) || STREAMING_PLATFORMS[STREAMING_PLATFORMS.length - 1];
}

export function socialMeta(value) {
  return SOCIAL_PLATFORMS.find((p) => p.value === value) || SOCIAL_PLATFORMS[0];
}
